/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Audit_CsvInputs */

const en_fw_audit_csv = /** @type {(inputs: Fw_Audit_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV`)
};

const id_fw_audit_csv = /** @type {(inputs: Fw_Audit_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV`)
};

/**
* | output |
* | --- |
* | "CSV" |
*
* @param {Fw_Audit_CsvInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_audit_csv = /** @type {((inputs?: Fw_Audit_CsvInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Audit_CsvInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_audit_csv(inputs)
	return en_fw_audit_csv(inputs)
});